export default __webpack_public_path__ + "static/media/settings.80795659.svg";